module.exports = __webpack_public_path__ + "static/media/repentance.6beb54d3.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/hymns/repentance.pdf
// module id = 789
// module chunks = 2